export default {
  data() {
    return {
      modalConfirmClone: {
        show: false,
        loading: false,
      },
    }
  },

  methods: {
    openCloneModal() {
      this.modalConfirmClone.show = true
    },
    handleCloseCloneModal() {
      this.modalConfirmClone.show = false
    },
    handleCancleCloneModal() {
      this.modalConfirmClone.show = false
    },
    async handleConfirmCloneModal({
      payload,
      createApiFn,
      redirectTo,
      refCode, // ex: so.so_code
    }) {
      this.modalConfirmClone.loading = true
      const response = await createApiFn(payload)
      if (response.success) {
        const docCode = (() => {
          let result = response.data
          const keys = refCode.split('.')
          for (const key of keys) {
            result = result[key]
          }
          return result
        })()
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: docCode }),
          color: 'success',
          icon: 'cloud',
        })
        this.modalConfirmClone.loading = false
        this.modalConfirmClone.show = false
        return this.$router.push({ name: redirectTo })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/confirmClone.js